import { FloatField } from '@components/Fields/FloatField';
import { StringField } from '@components/Fields/StringField';
import { IForm } from '@hooks/useForm';
import { Grid } from '@material-ui/core';
import { ICaixaRegistrarRequest } from '@services/CaixaService';
import React from 'react';

export type CaixaRegistrarFormProps = {
    form: IForm<ICaixaRegistrarRequest>
}

export function CaixaRegistrarForm ({ form }: CaixaRegistrarFormProps) {
    return (
        <Grid container spacing={1}>
            <Grid item xs={9}>
                <StringField 
                    field={form.fields.descricao}
                    label="Descrição"
                    required
                />
            </Grid>

            <Grid item xs={3}>
                <FloatField
                    field={form.fields.valor}
                    label="Valor"
                    required
                />
            </Grid>
        </Grid>
    )
}